import { getLocalInspectionsInStatus, copyInspection, deleteCopiedInspection } from "../data/inspections.js";

export const LOAD_LOCAL_INSPECTIONS = "LOAD_LOCAL_INSPECTIONS";
export const COPY_LOCAL_INSPECTION = "COPY_LOCAL_INSPECTION";
export const DELETE_COPIED_INSPECTION = "DELETE_COPIED_INSPECTION";

export function loadLocalInspections() {
	return (dispatch, getState) => {
		getLocalInspectionsInStatus("inProgress")
			.then(a => a || [])
			.then(a => dispatch(loadSuccess(a)));
	};
}

export const deleteCopiedInspectionAct = (inspToDel) => (dispatch, getState) => {
	return deleteCopiedInspection(inspToDel)
		.then((deleted) => {
			return dispatch({
				type: DELETE_COPIED_INSPECTION,
				copiedInsp: deleted
			});
		}).then(() => {
			return getLocalInspectionsInStatus("inProgress")
				.then(a => a || [])
				.then(a => dispatch(loadSuccess(a)));
		});
};

export const copyLocalInspection = (inspToCopy) => (dispatch, getState) => {
	return copyInspection(inspToCopy)
		.then((copiedInsp) => {
			dispatch({
				type: COPY_LOCAL_INSPECTION,
				copiedInsp: copiedInsp
			})
		});
};

const loadSuccess = i => ({
	type: LOAD_LOCAL_INSPECTIONS,
	inspections: i
});
